import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core'
import { Router } from '@angular/router'
import { ManageStateService } from '@shared/manage-state.service'
import { TokenService } from '@components/auth/token.service'
import { UrlVariable } from '@util/variable'

import { NotificationService } from '@shared/utils/notification.service'
// <div id="bigBox1" class="bigBox animated fadeIn fast" style="background-color: rgb(229, 13, 11);"><div id="bigBoxColor1"><i class="botClose fa fa-times" id="botClose1"></i><span>LỖI SML</span><p>Lỗi của thằng thành</p><div class="bigboxicon"><i class="fa fa-warning shake animated"></i></div><div class="bigboxnumber">1</div></div></div>
@Component({
  selector: 'dashboard-component',
  templateUrl: './dashboard.component.html',
  // template: `
  //   <div>
  //     <a (click)="showBigBoxError()" class="btn btn-primary">
  //       Sử dụng khi có lỗi
  //     </a>

  //     <a (click)="showSmallSuccess()" class="btn btn-primary">
  //       Sử dụng khi hiện success
  //     </a>



  //   </div>
  //   `,
  styleUrls: ['./dashboard.component.scss'],
})
export class DashBoardComponent implements OnInit {
  // private rootLinkERP = UrlVariable.URL_ROOT_ERP
  // private rootLinkPortal = UrlVariable.URL_ROOT_PORTAL
  constructor(
    private manageStateService: ManageStateService,
    private service: TokenService,
    private notificationService: NotificationService,
    private router: Router
  ) {
  }

  ngOnInit() { }

  public showBigBoxError() {
    this.notificationService.bigBox({
      title: 'LỖI SML',
      content: 'Lỗi của thằng thành',
      color: '#e50d0b',
      //timeout: 6000,
      icon: 'fa fa-warning shake animated',
      number: '1',
    })
  }

  public showSmallSuccess() {
    this.notificationService.smallBox({
      title: 'Tốt Lắm',
      content: 'Bạn đã giúp ích cho tổ chức HUTECH',
      color: '#739E73',
      iconSmall: 'fa fa-cloud',
      timeout: 5000,
    })
  }

  goToKhaiBaoYTe() {
    this.router.navigate(['/admin/khai-bao-y-te/update-sv']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/admin/dashboard.component.ts